import { styled } from '@linaria/react';
import { layout, space } from '../../theme/tokens';

export const FilterContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: flex-start;
  gap: ${space['space-400']};
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    grid-template-columns: auto auto;
    justify-content: flex-end;
    align-items: center;
    gap: ${space['space-200']};
  }
`;

export const CategoryDropdownContainer = styled.div`
  width: 100%;
`;
